export default __webpack_public_path__ + "static/media/frm.c2ff03d0.png";